import { TrendingDown, TrendingUp } from 'lucide-react';
import { formatINRCompact, formatPercentChange } from '../../utils/formatters';

export function MetricCard({ label, value, changePct, isInverse = false }) {
  const up = changePct != null && changePct > 0;
  const down = changePct != null && changePct < 0;
  const good = isInverse ? down : up;
  const bad = isInverse ? up : down;

  return (
    <div className="rounded-xl border border-slate-200/80 bg-white p-4 shadow-sm transition hover:shadow-md">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
      <p className="mt-1 text-2xl font-bold text-slate-900">{value}</p>
      {changePct != null && !Number.isNaN(changePct) && (
        <p
          className={`mt-1 flex items-center gap-1 text-sm font-medium ${
            good ? 'text-emerald-600' : bad ? 'text-red-600' : 'text-slate-500'
          }`}
        >
          {good ? <TrendingUp className="h-4 w-4" /> : bad ? <TrendingDown className="h-4 w-4" /> : null}
          {formatPercentChange(changePct)} vs last month
        </p>
      )}
    </div>
  );
}

export function MetricCardINR({ label, amount, changePct, isInverse }) {
  return (
    <MetricCard
      label={label}
      value={formatINRCompact(amount)}
      changePct={changePct}
      isInverse={isInverse}
    />
  );
}
